import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ITransaction, PresaleTransacationService } from '../../services/presale-transactions.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-notification-purchase',
  templateUrl: './notification-purchase.component.html',
  styleUrl: './notification-purchase.component.scss'
})
export class NotificationPurchaseComponent {
 constructor(
    private TransactionService: PresaleTransacationService,
    @Inject(PLATFORM_ID) private platform_id: Object,
  ) {
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platform_id)) {
      this.getTokenTransactions()
    }
  }

  async getTokenTransactions() {
    (await this.TransactionService.getTransactions()).subscribe((items: any) => {
      console.log({items});
      this.TransactionService.setAllTransaction(items?.result || []);
      this.TransactionService.startListner()      
    });
  }

   get transactions() {
    return this.TransactionService.transactions
   }

}
